import { GridConfig } from '@customer-portal/shared';

import { SaveSiteNicknamePayload } from '../../models';

export class LoadSettingsSitesList {
  static readonly type = '[Settings] Load Sites List';
}

export class UpdateSitesGridConfig {
  static readonly type = '[Settings] Update Site Grid Config';

  constructor(public sitesGridConfig: GridConfig) {}
}

export class UpdateSitesFilterOptions {
  static readonly type = '[Settings] Update Sites Filter Options';
}

export class ResetSitesListState {
  static readonly type = '[Settings] Reset Sites List State';
}

export class SelectSiteForNickname {
  static readonly type = '[Settings Sites] Select Site for Nickname';

  constructor(public siteId: string | number | null) {}
}

export class SubmitSiteNickname {
  static readonly type = '[Settings Sites] Submit Site Nickname';

  constructor(public payload: SaveSiteNicknamePayload) {}
}

export class SubmitSiteNicknameSuccess {
  static readonly type = '[Settings Sites] Submit Site Nickname Success';

  constructor(public payload: SaveSiteNicknamePayload) {}
}

export class SubmitSiteNicknameError {
  static readonly type = '[Settings Sites] Submit Site Nickname Error';

  constructor(public error: string) {}
}
